export enum UserSettingsTab {
  PROFILE = 'My profile',
  USERS = 'Users',
  INTEGRATIONS = 'Integrations',
  ENVIRONMENTS = 'Environments',
  AGENTIC_FEATURES = 'Agentic features',
  MCP_CONNECTIONS = 'MCP connections',
}
